import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useMp3Player } from '../providers/mp3PlayerContext';
import React, { useEffect, lazy, Suspense } from 'react';
import { ToastManager, notifyWithToast } from '../comps/templateToast';

const MediaPlayerToast = lazy(() => import('../comps/mediaPlayerToast'));

const LoadingComponent = () => <div style={{ display: 'none' }}></div>;

export default () => {

    const location = useLocation();
    const { setIsPlaying, setToastDisplay } = useMp3Player();

    useEffect(() => {
        const isRootPage = location.pathname === '/';
        const hasSeenMusicSuggestion = sessionStorage.getItem('hasSeenMusicSuggestion');

        if (isRootPage && !hasSeenMusicSuggestion) {

            const timer = setTimeout(() => {
                notifyWithToast('Hey There 🖐 ..',
                    `Would you like to listen to good music while you're here ?`,
                    {
                        name: 'Play ..',
                        impl: () => {
                            setToastDisplay(true);
                            setIsPlaying(true);
                        }
                    }, undefined, 5000);

                sessionStorage.setItem('hasSeenMusicSuggestion', 'true');
            }, 1000);

            return () => clearTimeout(timer);
        }
    }, [location.pathname, setIsPlaying, setToastDisplay]);


    return (
        <>
            <Outlet />
            <ToastManager />
            <Suspense fallback={<LoadingComponent />}>
                <MediaPlayerToast />
            </Suspense>
        </>
    );
};







// `Would you like to listen to good music while you're here ?`,

